
<template>
    <transition name="modal-fade">
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('activityDelete') }}</h5>
                    <button type="button" class="btn-close" data-dismiss="modal" @click="close" aria-label="Close" />
                </div>
                <div class="modal-body">
                    <template  v-if="this.$parent.foundActivities.length > 0">
                        <label class="form-label">{{ $t('cannotDeleteActivity') }}</label>
                        <div v-for="(activity, i) in this.$parent.foundActivities" :key="i">
                            <RouterLink :to="buildRouterLink(activity)">
                                {{ activity.name }}
                            </RouterLink>
                        </div>
                    </template>
                    <p v-else>{{ $t('wannaDeleteThisActivity') }}</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="close" data-dismiss="modal" >
                        {{ $t('close') }}
                    </button>
                    <button type="button" class="btn btn-primary" @click="deleteActivity" :disabled="this.$parent.foundActivities.length > 0">
                        {{ $t('delete') }}
                    </button>
                </div>
                </div>
            </div>
        </div>      
    </transition>
</template>

<script>
import ActivityApi from "../../api/server/activity";

export default {
    name: "activityDeleteModal",
    methods: {
        close() {
            this.$emit("closeDeleteDialog");
        },
        buildRouterLink(activity) {
            if(activity.type == "curve")
                return '/modeling/' + this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId + '/curve/' + activity.curveId;
            else 
                return '/modeling/' + this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId + '/lifecycle/' + activity.lifeCycleId;
        },
        async deleteActivity() {
            await ActivityApi.activityDelete(this.$parent.$route.params.id, this.$parent.activityToDeleteId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        }
    }
};
</script>